/* Program Name: Content.js
 **  Description: layout for a major of the application
 **
 **
 ** Project   Date        Who  Comments
 ** --------  ----------  ---  ---------------------------------------------------
 ** IS200243  2022-11-07  STT  Initial program
 *********************************************************************************/

/**React imports */
import React from 'react'

/**ezPOP imports */
import { DEV_GREEN, QA_YELLOW, subdomain } from '../ezpopURL'

/**MUI imports */
import { useTheme } from '@mui/material'

/**GeneralLayout **************************************************************/

const Content = (props) => {
  /****************************************************************************/
  /**Local Variables */

  //Conext end point that allows access to application theme
  const theme = useTheme()

  //determining the color of the gradient on the bottom of the content screen
  //based on development server level
  const color = subdomain.includes('-dev')
    ? DEV_GREEN
    : subdomain.includes('-qa')
    ? QA_YELLOW
    : theme.palette.secondary.main

  /****************************************************************************/
  /**Rendering */

  return (
    <div
      style={{
        width: '100%',
        backgroundColor: '#ffffff',
        minHeight: '100vh',
        background:
          'radial-gradient(at 15% 0%, #EFEFEFFE 70%, #EFEFEF50),' +
          'linear-gradient(135deg,' +
          color +
          '0D 60%,' +
          color +
          '1A 60%, ' +
          color +
          '1A 68%, ' +
          color +
          '33 68%, ' +
          color +
          '33 76%, ' +
          color +
          '40 76%, ' +
          color +
          '40 84%, ' +
          color +
          '66 84%, ' +
          color +
          '4D 92%, ' +
          color +
          '80 92%),' +
          'linear-gradient(45deg,' +
          theme.palette.primary.main +
          '40 48%,  ' +
          theme.palette.primary.main +
          '4D 48%,  ' +
          theme.palette.primary.main +
          '4D 56%,  ' +
          theme.palette.primary.main +
          '59 56%,  ' +
          theme.palette.primary.main +
          '59 64%,  ' +
          theme.palette.primary.main +
          '40 64%,  ' +
          theme.palette.primary.main +
          '40 72%,  ' +
          theme.palette.primary.main +
          '4D 72%,  ' +
          theme.palette.primary.main +
          '4D 80%,  ' +
          theme.palette.primary.main +
          '59 80%), ' +
          'linear-gradient(-90deg,rgba(122,122,122,0) 5%, ' +
          'rgba(122,122,122,.3) 5%, ' +
          'rgba(122,122,122,.3) 10%, ' +
          'rgba(122,122,122,.5) 10%, ' +
          'rgba(122,122,122,.5) 15%, ' +
          'rgba(122,122,122,.7) 15%, ' +
          'rgba(122,122,122,.7) 20%, ' +
          'rgba(122,122,122,.8) 20%), ' +
          'linear-gradient(90deg,' +
          color +
          '1A 80%, ' +
          color +
          '66 80%, ' +
          color +
          '66 85%, ' +
          color +
          '80 85%, ' +
          color +
          '80 90%, ' +
          color +
          '99 90%, ' +
          color +
          '99 95%, ' +
          color +
          'BF 95%)',
        //linear-gradient(rgba(0, 255, 0, .7) .1em, transparent .1em), linear-gradient(90deg, rgba(0, 255, 0, .7) .1em, transparent .1em);
        //background: "linear-gradient(135deg, #FFFFFF 76%, "+theme.palette.secondary.main+"1A 80%, "+theme.palette.secondary.main+"33 84%, "+theme.palette.secondary.main+"4D 84%, "+theme.palette.secondary.main+"4D 88%, "+theme.palette.secondary.main+"66 88%, "+theme.palette.secondary.main+"66 92%, "+theme.palette.secondary.main+"80 92%, "+theme.palette.secondary.main+"80 96%, "+theme.palette.secondary.main+"99 96%),linear-gradient(180deg, rgba(224, 224, 224, 0) 84%, rgba(224, 224, 224,.1) 84%, rgba(224, 224, 224,.1) 88%, rgba(224, 224, 224,.2) 88%, rgba(224, 224, 224,.2) 92%, rgba(224, 224, 224,.4) 92%, rgba(224, 224, 224,.4) 96%, rgba(224, 224, 224,.6) 96%), linear-gradient(90deg, rgba(224, 224, 224,0) 84%, rgba(224, 224, 224,.3) 84%, rgba(224, 224, 224,.3) 88%, rgba(224, 224, 224,.5) 88%, rgba(224, 224, 224,.5) 92%, rgba(224, 224, 224,.7) 92%, rgba(224, 224, 224,.7) 96%, rgba(224, 224, 224,.8) 96%)",
        //linear-gradient("+theme.palette.primary.main+"4D, "+theme.palette.secondary.main+"4D), linear-gradient(45deg, "+theme.palette.primary.main+"4D 20%, "+theme.palette.primary.main+"66 20%, "+theme.palette.primary.main+"66 40%, "+theme.palette.primary.main+"80 40%, "+theme.palette.primary.main+"80 60%, "+theme.palette.primary.main+"99 60%, "+theme.palette.primary.main+"99 80%, "+theme.palette.primary.main+"B3 80%), ,
        //linear-gradient(135deg, #FFFFFF 50%, "+theme.palette.secondary.main+"33),
        //backgroundSize: '100% 100%',
      }}
    >
      {props.children}
    </div>
  )
}

export default Content
